import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const removeAttributeFromSensitivePropertyGroup =
  (groupName: string, attributeIri: string) => (model: Model) => {
    const existingAttributeIris =
      model.modelData.sensitivePropertyGroupsByName[groupName];

    if (
      !existingAttributeIris ||
      !existingAttributeIris.includes(attributeIri)
    ) {
      return;
    }

    setDataProperty<ModelData>(model)(
      model.modelData,
      'sensitivePropertyGroupsByName',
      {
        ...model.modelData.sensitivePropertyGroupsByName,
        [groupName]: existingAttributeIris.filter(
          (iri: string) => iri !== attributeIri
        ),
      }
    );
  };
